import React from "react";

const About = () => {
  return (
    <div className="p-20 mx-auto max-w-[1190px] h-full">
      <div>
        <p className="font-bold text-[24px] mb-8">About Us</p>
        <p className="text-info text-[16px]">
          This Privacy Policy describes how Substance collects, uses and
          discloses information, and what choices you have with respect to the
          information. <br /> <br />
          When we refer to “Substance”, we mean the Substance entity that acts
          as the controller or processor of your information, as explained in
          more detail in the “Identifying the Data Controller and Processor”
          section below.
        </p>

        <p className="font-bold text-[24px] mb-6 mt-12">
          Applicability Of This Privacy Policy
        </p>
        <p className="text-info text-[16px]">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
          <br />
          <br />
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem
          accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
          ab illo inventore veritatis et quasi architecto beatae vitae dicta
          sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
          aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos
          qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui
          dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed
          quia non numquam eius modi tempora incidunt ut labore et dolore magnam
          aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum
          exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex
          ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in
          ea voluptate velit esse quam nihil molestiae consequatur, vel illum
          qui dolorem eum fugiat quo voluptas nulla pariatur?
        </p>
      </div>
    </div>
  );
};

export default About;

// Developed By
// Md.Shefat Zeon
// 2023-05-23
